/* The enabled set — STORY-041.
 *
 * Which currencies and timezones one Organisation offers in its everyday
 * pickers. What is *supported* is every ISO 4217 code and every IANA zone, read
 * from the platform at runtime; what is *enabled* is this. `i18n.md` forbids a
 * committed list of supported values and this is not one — it is per-workspace
 * data an Owner changes from Settings without a deploy.
 */
import * as z from 'zod';
/**
 * Currencies and timezones are one set with a discriminator rather than two.
 *
 * They behave identically — enable, disable, never leave the set empty, never
 * touch stored data — so one shape means one set of rules. Two would be two
 * copies of those rules, and the second copy is the one that drifts.
 */
export const ENABLED_KINDS = ['currency', 'timezone'];
export const enabledValueSchema = z.object({
    kind: z.enum(ENABLED_KINDS),
    /* An ISO 4217 code or an IANA identifier, exactly as the runtime spells it.
     * Never an offset — offsets change twice a year and are not identity. */
    value: z.string(),
    /**
     * How many records carry this value.
     *
     * Derived on every read, never stored: a stored count is a number that goes
     * wrong quietly. It decides whether disabling asks for confirmation, and the
     * confirmation's whole message is this number — "EUR is on 34 transactions;
     * they keep it".
     */
    inUse: z.number().int().nonnegative(),
});
export const enabledValuesResponseSchema = z.object({
    values: z.array(enabledValueSchema),
});
/* Long enough for `America/Argentina/Rio_Gallegos`, short enough that nobody is
 * writing a paragraph into a picker. The real check is that the runtime knows
 * the value, which the server does against `Intl` — a length bound is only what
 * stops an unbounded string reaching that check. */
export const ENABLED_VALUE_MAX = 64;
export const enableValueRequestSchema = z.object({
    kind: z.enum(ENABLED_KINDS),
    value: z.string().trim().min(1).max(ENABLED_VALUE_MAX),
});
//# sourceMappingURL=enabled-values.js.map